import styles from './ccf-open-with-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';
/* eslint-disable-next-line */
export interface CcfOpenWithIconProps extends SvgIconProps{}
/**
 * CcfOpenNewTabIcon used to disply open new tab icon in the custom workspace iframe panel
 * @param props - SvgIconProps
 * @example -- <CcfOpenNewTabIcon />
 */
export function CcfOpenWithIcon(props: CcfOpenWithIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M0.55 3.8C0.88 3.8 1.1 3.58 1.1 3.25V2.48L3.135 4.515L3.905 3.745L1.76 1.6H2.75C3.08 1.6 3.3 1.38 3.3 1.05C3.3 0.72 3.08 0.5 2.75 0.5H0.55C0.22 0.5 0 0.72 0 1.05V3.25C0 3.58 0.22 3.8 0.55 3.8Z" fill="#526B7A"/>
<path d="M2.75 10.4H1.925L3.96 8.365L3.19 7.595L1.1 9.685V8.75C1.1 8.42 0.88 8.2 0.55 8.2C0.22 8.2 0 8.42 0 8.75V10.95C0 11.28 0.22 11.5 0.55 11.5H2.75C3.08 11.5 3.3 11.28 3.3 10.95C3.3 10.62 3.08 10.4 2.75 10.4Z" fill="#526B7A"/>
<path d="M10.45 8.2C10.12 8.2 9.9 8.42 9.9 8.75V9.74L7.755 7.595L6.985 8.365L9.02 10.4H8.25C7.92 10.4 7.7 10.62 7.7 10.95C7.7 11.28 7.92 11.5 8.25 11.5H10.45C10.78 11.5 11 11.28 11 10.95V8.75C11 8.42 10.78 8.2 10.45 8.2Z" fill="#526B7A"/>
<path d="M10.45 0.5H8.25C7.92 0.5 7.7 0.72 7.7 1.05C7.7 1.38 7.92 1.6 8.25 1.6H9.185L7.04 3.745L7.81 4.515L9.9 2.425V3.25C9.9 3.58 10.12 3.8 10.45 3.8C10.78 3.8 11 3.58 11 3.25V1.05C11 0.72 10.78 0.5 10.45 0.5Z" fill="#526B7A"/>
    </SvgIcon>
  );
}

export default CcfOpenWithIcon;
